import { Link, useLocation } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { shortId } from '../lib/format';

export default function OrderSuccess() {
  const { t } = useLang();
  const { state } = useLocation();

  return (
    <div className="container section" style={{ maxWidth: 560, textAlign: 'center' }}>
      <div style={{ fontSize: 56 }}>🎉</div>
      <h1>{t('ok.title')}</h1>
      <p>{t('ok.body')}</p>
      {state?.orderId && (
        <p><strong>{t('ok.code')}:</strong> <code>{shortId(state.orderId)}</code></p>
      )}
      <Link to="/" className="btn btn-primary">{t('ok.back')}</Link>
    </div>
  );
}
